

import styled from "styled-components"
import { useSelector } from "react-redux"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useState } from "react"
import NakliyeCityIndex from "../../components/nakliyeIndex/NakliyeCityIndex"

import TopMenus from "../../components/shared/TopMenus"
import NakliyeKaynakVerileri from "../../components/nakliyeIndex/NakliyeKaynakVerileri"
import NakliyeIsSezonIndex from "../../components/nakliyeIndex/NakliyeIsSezonIndex"
import NakliyeCityToCityIndex from "../../components/nakliyeIndex/NakliyeCityToCityIndex"
import NakliyeIklimIndex from "../../components/nakliyeIndex/NakliyeIklimIndex"
import NakliyeCityToTownIndex from "../../components/nakliyeIndex/NakliyeCityToTownIndex"
import NakliyeKarIndex from "../../components/nakliyeIndex/NakliyeKarIndex"
import NakliyeIndex4Result from "../../components/nakliyeIndex/NakliyeIndex4Result"

const Container = styled.div`
    width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;
        color: ${({theme}) => theme.mainTextColor};

        .content{
            margin: 0 30px;
            margin-top: 40px;
            display: flex;
            flex-direction: column;
            margin-bottom: 100px;

            .main-content{
                width: 100%;
                padding: 40px 0;

            }

        }
    }
`

const menulist = [
    {
        id: 1,
        text: "İndeks-1(Kar İndeksi)"
    },
    {
        id: 2,
        text: "İndeks-2 (İl İndeksi)"
    },
    {
        id: 3,
        text: "İndeks-3 (İş Sezonu İndeksi) "
    },
    {
        id: 4,
        text: "İndeks-4 (İllerarası İndeksi) "
    },
    {
        id: 5,
        text: "İndeks-5 (İlçe İndeksi)"
    },
    {
        id: 6,
        text: "İndeks-6 (Kış Şartları İndeksi)"
    },
    {
        id: 7,
        text: "Nakliye Kaynak Verileri"
    },
    {
        id: 8,
        text: "SONUÇ"
    }
]


const NakliyeIndex = () => {

    const [activeMenuId ,setActiveMenuId] = useState(1)

  return (
    <Container>
      <div className="wrapper">
            <PageTopTitle title={"Nakliye İndex"}/>
            <div className="content">
                <TopMenus menuList={menulist} activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId}/>
                <div className="main-content">
                    {
                        activeMenuId === 1 &&
                        <NakliyeKarIndex/>
                    }

                    {
                        activeMenuId === 2 &&
                        <NakliyeCityIndex/>
                    }

                    {
                        activeMenuId === 3 &&
                        <NakliyeIsSezonIndex />
                    }

                    {
                        activeMenuId === 4 &&
                        <NakliyeCityToCityIndex />
                    }

                    {
                        activeMenuId === 5 &&
                        <NakliyeCityToTownIndex />
                    }

                    {
                        activeMenuId === 6 &&
                        <NakliyeIklimIndex />
                    }

                    {
                        activeMenuId === 7 &&
                        <NakliyeKaynakVerileri />
                    }

                    {
                        activeMenuId === 8 &&
                        <NakliyeIndex4Result/>
                    }

                </div>
            </div>
        </div>
    </Container>
  )
}

export default NakliyeIndex